import { Modal } from 'antd';
import Router from 'next/router';
import { changeStatusAction } from '@gtintel/platform-api';
import { CLOSED_ID, COMPLETE_ID, COOKIE_NAMES, PROJECT_ACTIVATED_ID, SCOPING_ID, TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
import { sendNotifications, sendNotificationsAsAdmin } from '@gtintel/platform-firebase';
import { RouteRolesEnum } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
const {
  confirm
} = Modal;
export function changeProjectStatus(statusId, routeRole) {
  this.setState({
    loading: true
  });
  const {
    projects,
    partnerProposal
  } = this.state;
  const partner_identity = partnerProposal.result.id;
  const client = routeRole === RouteRolesEnum.CLIENT ? getSessionStorageItem(COOKIE_NAMES.INFOR_USER) : projects.client;
  const param = {
    status: statusId
  };
  return changeStatusAction(this.props.query?.id ?? projects.id, param).then(async statusAction => {
    if (routeRole === RouteRolesEnum.CLIENT) {
      projects.status = statusAction.status;
      if (statusId === SCOPING_ID) {
        this.sendMessengerTo(partner_identity, projects.twilio_client_partner, 'project');
        this.sendNotification(projects.partner, 'change status to scoping', TWILIO_ADMIN_IDENTITY, true);
      }
      if (statusId === PROJECT_ACTIVATED_ID) {
        this.sendNotification(client, projects, projects.partner, 'has activated the project', TWILIO_ADMIN_IDENTITY, true);
      }
      this.setState({
        projects
      });
    } else if (routeRole === RouteRolesEnum.ADMIN) {
      if (statusId === PROJECT_ACTIVATED_ID || statusId === COMPLETE_ID) {
        await sendNotificationsAsAdmin({
          project: projects,
          content: `has ${statusId === PROJECT_ACTIVATED_ID ? 'activated' : 'completed'} the project`,
          redirectLink: `/project/detail/${projects.id}`,
          sendToClient: client && projects.id,
          sendToPartner: projects.partner && projects.id
        });
      }
      Router.reload();
    } else if (routeRole === RouteRolesEnum.PARTNER) {
      projects.status = statusAction.status;
      const partner = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
      if (statusId === SCOPING_ID) {
        this.sendMessengerTo(client?.id, projects.twilio_client_partner, 'project');
        await sendNotifications({
          user: partner,
          project: projects,
          content: 'has activated the project',
          redirectLink: `/project/detail/${projects.id}`,
          sendToClient: client && projects.id,
          sendToAdmin: true
        });
      }
      this.setState({
        projects
      });
    }
  }).catch(() => {
    Router.reload();
  }).finally(() => {
    this.setState({
      loading: false
    });
  });
}
export function changeProjectStatusToActivated(routeRole, title, content, okText) {
  confirm({
    title: title ?? 'Are you sure you want to activate this project?',
    content: content ?? 'By clicking "Activate Project" you agree to incur fees as detailed in the Project Overview and in accordance with your Services Agreement with Ground Truth Intelligence Limited.',
    okText: okText ?? 'ACTIVATE PROJECT',
    okType: 'primary',
    cancelText: 'CANCEL',
    onOk: () => {
      this.changeStatus(PROJECT_ACTIVATED_ID, routeRole);
    }
  });
}
export function changeProjectStatusToClosed(closedDate) {
  const {
    projects
  } = this.state;
  const client = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
  confirm({
    title: 'Close Project?',
    content: `Once you close this project, the Network Partner will no longer have access to the project space or chat, and you will have until ${closedDate} to export any project materials that you wish to save before they are removed from our servers.`,
    okText: 'CLOSE PROJECT',
    okType: 'primary',
    cancelText: 'CANCEL',
    onOk: () => {
      this.changeStatus(CLOSED_ID, RouteRolesEnum.CLIENT);
      this.sendNotification(client, projects, projects.partner, 'report accepted', TWILIO_ADMIN_IDENTITY, true);
    }
  });
}